import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Box = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M26.83 2.55401C25.6553 2.08193 24.3446 2.08193 23.1699 2.55401L3.56461 10.4351C3.16096 10.5976 2.81563 10.8776 2.57265 11.2384C2.3297 11.5992 2.20005 12.0245 2.19995 12.4593V36.3956C2.20068 37.1072 2.41365 37.8025 2.81183 38.3919C3.20986 38.981 3.7757 39.4378 4.43522 39.7019L24.1901 47.6431C24.7098 47.8522 25.2905 47.852 25.8103 47.6429L45.5682 39.7016C46.2274 39.4369 46.792 38.9802 47.1895 38.3908C47.5871 37.8015 47.7995 37.106 47.7999 36.3948V12.4592C47.7999 12.0243 47.6702 11.5992 47.4273 11.2384C47.1843 10.8776 46.8385 10.5975 46.4348 10.4349L26.83 2.55401ZM24.7873 6.60549C24.9239 6.55049 25.076 6.55049 25.2126 6.60549L29.4654 8.31441L14.6874 14.2527L10.2223 12.4591L24.7873 6.60549ZM20.5349 16.6041L35.3125 10.666L39.7775 12.4595L24.9999 18.3976L20.5349 16.6041ZM6.54995 35.8542V15.685L22.825 22.2239V42.3956L6.54995 35.8542ZM27.175 42.3928V22.2266L43.45 15.6851V35.8514L27.175 42.3928Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  )
}
